module.exports = __webpack_public_path__ + "img/Piece-18-4-mobile.a65688c6.png";